export default "__VITE_ASSET__2gr54cDm__"